angular.module('dnecom')
    .controller('ServiceProfileModalController', ServiceProfileModalController);

ServiceProfileModalController.$inject = ['$scope', '$uibModalInstance', 'serviceProfile', '$http', 'notifications', 'ErrorBag'];

function ServiceProfileModalController($scope, $uibModalInstance, serviceProfile, $http, notifications, ErrorBag) {
    $scope.serviceProfile = angular.copy(serviceProfile);

    $scope.save = function() {
        $scope.serverErrors = {};
        $scope.loading = true;
        var serviceProfile = $scope.serviceProfile;
        var id = 0;
        if (serviceProfile.hasOwnProperty('id')) {
            id = serviceProfile.id;
        }

        var url = null;

        if (id) {
            url = Routing.generate('instruction_profiles_update', {
                id: id
            });
        } else {
            url = Routing.generate('instruction_profiles_add', {});
        }

        $http.put(url, serviceProfile)
            .then(function(response) {
                $scope.loading = false;
                if (response.data.success) {
                    notifications.success('Service profile saved.');
                    $scope.serviceProfile = response.data.serviceProfile;

                    $uibModalInstance.close({
                        serviceProfile: $scope.serviceProfile
                    });
                } else {
                    notifications.danger(response.data.message);
                }
            }, function(response) {
                $scope.loading = false;
                if (response.status == 422) {
                    notifications.danger('Form contains invalid data.');

                    $scope.serverErrors = ErrorBag.from(response.data.errors);
                } else {
                    notifications.danger('Request error.');
                }
            });
    };


    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.checkLength = () => {
        if ($scope.serviceProfile.instructionText && $scope.serviceProfile.instructionText.length > 1000) {
            $scope.serviceProfile.instructionText = $scope.serviceProfile.instructionText.substring(0, 1000);
        }
    };
};
